import { trackLpInteraction } from '~/helpers/datalayer-actions'

export default () => {
  function init() {
    if (window.cnvs.request.pageType !== 'page') {
      return
    }

    document
      .querySelectorAll('section[data-component-handle="quote-section"] a')
      .forEach((anchor) => {
        if (!anchor.href) {
          return
        }
        anchor.addEventListener('click', trackClick)
      })
  }

  function trackClick(event) {
    trackLpInteraction({
      event: 'lp_interaction',
      label: event.currentTarget.textContent,
      type: 'cta_click',
      source: 'quote section',
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
